import React, { useState } from "react";
import { useFilter } from "../context/FilterContext";

const AboutSideBar = ({ onSelect }) => {
  const [activeFolder, setActiveFolder] = useState("bio");
  const { selectedFilter, setSelectedFilter } = useFilter();
  const handleClick = (folderName) => {
    setActiveFolder(folderName);
    if (onSelect) {
      onSelect(folderName);
    }
    setSelectedFilter(folderName);
  };

  return (
    <div className="about-sidebar">
      <div className="folder-header">
        <div className="cell">
          {" "}
          <i className="fa-solid fa-sort-down"></i> personal-info
        </div>
      </div>
      <div className="folders">
        <div
          className={`folder folder-bio ${
            activeFolder === "bio" ? "active" : ""
          }`}
          onClick={() => handleClick("bio")}
        >
          <i className="fa-solid fa-chevron-right"></i>{" "}
          <i className="fa-solid fa-folder"></i> bio <br />
        </div>
        <div
          className={`folder folder-interests ${
            activeFolder === "interests" ? "active" : ""
          }`}
          onClick={() => handleClick("interests")}
        >
          <i className="fa-solid fa-chevron-right"></i>{" "}
          <i className="fa-solid fa-folder"></i> interests
          <br />
        </div>
        <div
          className={`folder folder-experience ${
            activeFolder === "experience" ? "active" : ""
          }`}
          onClick={() => handleClick("experience")}
        >
          <i className="fa-solid fa-chevron-right"></i>{" "}
          <i className="fa-solid fa-folder"></i> experience
        </div>
        <div
          className={`folder folder-js ${
            activeFolder === "index.js" ? "active" : ""
          }`}
          onClick={() => handleClick("index.js")}
        >
          <i className="fa-solid fa-chevron-right"></i>{" "}
          <i class="fa-brands fa-js"></i> index.js
        </div>
        <div
          className={`folder folder-readme ${
            activeFolder === "README.md" ? "active" : ""
          }`}
          onClick={() => handleClick("README.md")}
        >
          <i className="fa-solid fa-chevron-right"></i>{" "}
          <i class="fa-solid fa-circle-info"></i> README.md
        </div>
      </div>

      <div className="cell border-top contact-box">
        {" "}
        <i className="fa-solid fa-sort-down"></i> contact
      </div>

      <div className="folders contact-folders">
        <div className="folder link-folder">
          <i className="fa-solid fa-phone"></i>{" "}
          <a className="folder-link" href="tel:0031616150171">
            +31 616 15 01 71
          </a>
        </div>
        <div className="folder link-folder">
          <i className="fa-solid fa-envelope"></i>{" "}
          <a className="folder-link" href="mailto:mertarinci96@gmail.com">
            emailMe.js
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutSideBar;
